import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgShoppingBag = function SvgShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.746 3.18a.75.75 0 0 1 .081 1.058L6.388 8.25h11.74l-3.44-4.012a.75.75 0 1 1 1.14-.976l4.275 4.988h1.254a2.234 2.234 0 0 1 2.084 2.796l-2.134 8.985a2.192 2.192 0 0 1-2.1 1.719H5.306a2.192 2.192 0 0 1-2.1-1.72l-2.135-8.984a2.234 2.234 0 0 1 2.11-2.796h1.23l4.276-4.988a.75.75 0 0 1 1.058-.081ZM4.753 9.75H3.198a.734.734 0 0 0-.673.921l.004.02 2.138 9 .004.014c.067.312.34.537.658.545h13.856a.692.692 0 0 0 .658-.545l.003-.014 2.138-9 .005-.02a.734.734 0 0 0-.674-.921h-1.552a.69.69 0 0 1-.01 0H4.753Zm3.005 1.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Zm4.5 0a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Zm4.5 0a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })));
};

export { SvgShoppingBag as default };
//# sourceMappingURL=shopping-bag.svg.js.map
